import type { ZudokuConfig } from "zudoku";

export const extraConfig: ZudokuConfig = {
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        // Add navigation items here
        {
          type: "doc",
          file: "about",
          path: "/"
        },
        "changelog",
        {
          type: "category",
          label: "Getting Started",
          icon: "box",
          collapsible: false,
          items: [
            "getting-started/overview",
            "getting-started/registration",
            "getting-started/authorisation",
            "getting-started/calling-the-api"
          ]
        },
        {
          type: "category",
          label: "Guides",
          icon: "book-open-text",
          collapsible: false,
          items: [
            {
              type: "doc",
              file: "guides/migrating-from-trds"
            },
            "guides/account-opening",
            "guides/valuation"
          ]
        },
        {
          type: "category",
          label: "Advanced Topics",
          icon: "wrench",
          collapsible: false,
          items: [
            "advanced/environments",
            "advanced/scopes",
            "advanced/errors",
            "advanced/tokens",
            "advanced/pagination",
            "advanced/rate-limiting",
            "advanced/idempotency"
          ]
        },
        "contact-us"
      ]
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference"
    }
  ]
};
